$(function(){
    window.attachMobileGrowEffectOnBoxes();
});

window.attachMobileGrowEffectOnBoxes = function() {
    gsap.utils.toArray(".grid-item").forEach((item, i) => {
        gsap.to(item, {
            scrollTrigger: {
                trigger: item,
                start: "top center",
                end: "bottom center",
                onEnter: () => {
                    if (window.innerWidth < 578 && i != 0 && i != 1) {
                        var $item = $(item);
                        if (!$item.hasClass('hovered') && $item.hasClass('grow')) {
                            $item.addClass('hovered');
                        }
                    }
                },
                onLeave: () => {
                    if (window.innerWidth < 578 && i != 0 && i != 1) {
                        var $item = $(item);
                        if ($item.hasClass('hovered') && $item.hasClass('grow')) {
                            $item.removeClass('hovered');
                        }
                    }
                },
                onEnterBack: () => {
                    if (window.innerWidth < 578 && i != 0 && i != 1) {
                        var $item = $(item);
                        if (!$item.hasClass('hovered') && $item.hasClass('grow')) {
                            $item.addClass('hovered');
                        }
                    }
                },
                onLeaveBack: () => {
                    if (window.innerWidth < 578 && i != 0 && i != 1) {
                        var $item = $(item);
                        if ($item.hasClass('hovered') && $item.hasClass('grow')) {
                            $item.removeClass('hovered');
                        }
                    }
                }
            },
        })
    })
}